import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
// Service would normally be imported, but assuming we pass actions or use a hook
// import { notificationService } from '../../services/notificationService'; // Placeholder

export const GlobalPopup = ({ notifications, actions }) => {
    const [currentPopup, setCurrentPopup] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        // Filter notifications to find the next valid popup
        const nextPopup = notifications.find(n => {
            // Filter by Type = 'Popup' (we need to know how to identify it, maybe by property 'tipo' string 'Popup' or new field)
            // DTO has 'tipo': 'Popup'
            if (n.datos.tipo !== 'Popup') return false;

            // Filter by Date
            const now = new Date();
            const start = n.datos.fechaInicio ? new Date(n.datos.fechaInicio) : null;
            const end = n.datos.fechaFin ? new Date(n.datos.fechaFin) : null;

            if (start && now < start) return false;
            if (end && now > end) return false;

            // Filter by Acceptance/Read status (handled by backend mostly, but double check)
            // If requires acceptance, rely on backend sending it (meaning not accepted yet).
            // If session based (frecuencia === 1), check sessionStorage
            if (n.datos.frecuencia === 1) {
                if (sessionStorage.getItem(`popup_seen_${n.id}`)) return false;
            }

            return true;
        });

        if (nextPopup) {
            setCurrentPopup(nextPopup);
            setShow(true);
        }
    }, [notifications]);

    const handleClose = () => {
        if (!currentPopup) return;

        // Logic based on frequency
        if (currentPopup.datos.frecuencia === 1) {
            // Session based: mark in storage, don't tell backend to hide forever (unless it's just 'read')
            sessionStorage.setItem(`popup_seen_${currentPopup.id}`, 'true');
            setShow(false);
            // Note: We might NOT want to call markAsRead API if we want it to reappear in next session.
            // But if 'markAsRead' removes it from the list returned by API, then we lose it for next session.
            // ISSUE: If API doesn't return read notifications, and we don't mark it read, it will keep coming.
            // We handle that by sessionStorage check above.
        } else {
            // Once / Permanent: Call API to mark as read/closed.
            actions.handleMarkAsRead(currentPopup);
            setShow(false);
        }
    };

    const handleAccept = () => {
        if (!currentPopup) return;

        // Always call accept endpoint
        actions.handleAccept(currentPopup);
        setShow(false);
    };

    if (!currentPopup) return null;

    const isBlocking = currentPopup.datos.requiereAceptacion;

    return (
        <Modal show={show} onHide={isBlocking ? undefined : handleClose} backdrop={isBlocking ? 'static' : true} keyboard={!isBlocking} centered>
            <Modal.Header closeButton={!isBlocking}>
                <Modal.Title>{currentPopup.datos.titulonotificacion}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: currentPopup.datos.descripcion }} />
                {currentPopup.datos.imagenbanner && (
                    <img src={currentPopup.datos.imagenbanner} alt="Banner" className="img-fluid mt-3" />
                )}
            </Modal.Body>
            <Modal.Footer>
                {!isBlocking && (
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                )}
                <Button variant="primary" onClick={handleAccept}>
                    {isBlocking ? 'Aceptar y Continuar' : 'Entendido'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
